/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxGamesLibWebRpcContractsFxGamesResponseOfRedeemYandexBonusResultFromJSON, FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandToJSON, FxIdWebFeaturesStoreYandexGamesPurchaseRequestToJSON, FxIdWebFeaturesStoreYandexGamesPurchaseResponseFromJSON, } from '../models/index';
/**
 *
 */
export class YandexgamesApi extends runtime.BaseAPI {
    /**
     */
    async fxIdWebFeaturesStoreYandexGamesPurchaseEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError('game', 'Required parameter "game" was null or undefined when calling fxIdWebFeaturesStoreYandexGamesPurchaseEndpoint().');
        }
        if (requestParameters['fxIdWebFeaturesStoreYandexGamesPurchaseRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesStoreYandexGamesPurchaseRequest', 'Required parameter "fxIdWebFeaturesStoreYandexGamesPurchaseRequest" was null or undefined when calling fxIdWebFeaturesStoreYandexGamesPurchaseEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/yandexgames/purchase/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesStoreYandexGamesPurchaseRequestToJSON(requestParameters['fxIdWebFeaturesStoreYandexGamesPurchaseRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesStoreYandexGamesPurchaseResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesStoreYandexGamesPurchaseEndpoint(game, fxIdWebFeaturesStoreYandexGamesPurchaseRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesStoreYandexGamesPurchaseEndpointRaw({ game: game, fxIdWebFeaturesStoreYandexGamesPurchaseRequest: fxIdWebFeaturesStoreYandexGamesPurchaseRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `orders`, `orderproduct`, `promo_codes`  Redeems yandex bonus
     */
    async fxIdWebFeaturesStoreYandexGamesRedeemYandexBonusEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdApplicationStoreYandexGamesRedeemYandexBonusCommand'] == null) {
            throw new runtime.RequiredError('fxIdApplicationStoreYandexGamesRedeemYandexBonusCommand', 'Required parameter "fxIdApplicationStoreYandexGamesRedeemYandexBonusCommand" was null or undefined when calling fxIdWebFeaturesStoreYandexGamesRedeemYandexBonusEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/yandexgames/redeem-bonus`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationStoreYandexGamesRedeemYandexBonusCommandToJSON(requestParameters['fxIdApplicationStoreYandexGamesRedeemYandexBonusCommand']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsFxGamesResponseOfRedeemYandexBonusResultFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `orders`, `orderproduct`, `promo_codes`  Redeems yandex bonus
     */
    async fxIdWebFeaturesStoreYandexGamesRedeemYandexBonusEndpoint(fxIdApplicationStoreYandexGamesRedeemYandexBonusCommand, initOverrides) {
        const response = await this.fxIdWebFeaturesStoreYandexGamesRedeemYandexBonusEndpointRaw({ fxIdApplicationStoreYandexGamesRedeemYandexBonusCommand: fxIdApplicationStoreYandexGamesRedeemYandexBonusCommand }, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=YandexgamesApi.js.map